import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  injectDialogRef,
  NgpDialog,
  NgpDialogDescription,
  NgpDialogOverlay,
  NgpDialogTitle,
  provideDialogState,
} from 'ng-primitives/dialog';

import { IconComponent } from '@shared/icon';

import { dialogContent, dialogDescription, dialogOverlay, dialogTitle } from './dialog.cva';

@Component({
  selector: 'ml-dialog',
  imports: [NgpDialog, NgpDialogTitle, NgpDialogOverlay, NgpDialogDescription, IconComponent],
  providers: [provideDialogState()],
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  protected readonly dialogRef = injectDialogRef<string>();

  protected readonly overlayClasses = dialogOverlay;
  protected readonly contentClasses = dialogContent;
  protected readonly titleClasses = dialogTitle;
  protected readonly descriptionClasses = dialogDescription;

  protected closeDialog(): void {
    void this.dialogRef.close();
  }
}
